import {
  clearStorage,
  getStorageValue,
  removeStorageValue,
  setStorageValue,
} from '@/utils/storage/storage';

export interface ReadStorageValueProps<T> {
  storageKey: string;
  fallbackValue: T;
  shouldStoreAsJson?: boolean;
  validate: (persistedValue: unknown) => persistedValue is T;
}

export const readStorageValue = <T>({
  storageKey,
  fallbackValue,
  validate,
  shouldStoreAsJson = true,
}: ReadStorageValueProps<T>) => {
  const persistedValue = getStorageValue(storageKey);

  if (!persistedValue) {
    return fallbackValue;
  }

  try {
    const parsedValue = shouldStoreAsJson ? JSON.parse(persistedValue) : persistedValue;
    if (validate(parsedValue)) {
      return parsedValue;
    }
  } catch (error) {
    console.log(storageKey, 'is not stored as JSON');
  }

  return fallbackValue;
};

export interface SaveStorageValueProps<T> {
  storageKey: string;
  value: T;
  shouldStoreAsJson?: boolean;
}

export const saveStorageValue = <T>({
  storageKey,
  value,
  shouldStoreAsJson = true,
}: SaveStorageValueProps<T>) => {
  setStorageValue(storageKey, shouldStoreAsJson ? JSON.stringify(value) : String(value));
};

export { clearStorage, removeStorageValue };
